<template>
  <v-container>
    <component :is="currentView" v-model="currentCampaign" @handleChangeView="handleChangeView" />
  </v-container>
</template>

<script>
import List from './GameSetting/List.vue'
import Manage from './GameSetting/Manage.vue'
export default {
  data() {
    return {
      currentView: 'list', // list , add , edit
      currentCampaign: null
    }
  },
  components: {
    Manage,
    List
  },
  methods: {
    handleChangeView({ view, data = null }) {
      this.currentView = view
      this.currentCampaign = data
    }
  }
}
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/view/template/generalixwarroom/GameSetting.vue